import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

const AdUnit = () => {
  const adLoaded = useRef(false);

  useEffect(() => {
    if (!adLoaded.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adLoaded.current = true;
      } catch (error) {
        console.error("AdSense error:", error);
      }
    }
  }, []);

  return (
    <Box sx={{ flexGrow: 1, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <ins 
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '100%' }}
        data-ad-client="ca-pub-6963830729381696"
        data-ad-slot="1234567890" /* Placeholder slot, user will need their real slot ID */
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </Box>
  );
};

export default AdUnit;
